export const SUCCESS_SUBMIT_PROPOSAL_TENDER = 'SUCCESS_SUBMIT_PROPOSAL_TENDER';
export const FAIL_SUBMIT_PROPOSAL_TENDER = 'FAIL_SUBMIT_PROPOSAL_TENDER';
export const SUCCESS_SET_SELECTED_ITEMS_PR = 'SUCCESS_SET_SELECTED_ITEMS_PR';
export const FAIL_SET_SELECTED_ITEMS_PR = 'FAIL_SET_SELECTED_ITEMS_PR';
export const SUCCESS_GET_PROPOSAL_TENDER = 'SUCCESS_GET_PROPOSAL_TENDER';
export const FAIL_GET_PROPOSAL_TENDER = 'FAIL_GET_PROPOSAL_TENDER';
export const SUCCESS_UPDATE_PROPOSAL_TENDER = 'SUCCESS_UPDATE_PROPOSAL_TENDER';
export const FAIL_UPDATE_PROPOSAL_TENDER = 'FAIL_UPDATE_PROPOSAL_TENDER';
export const SUCCESS_GET_DETAIL_EVALUASI_MONITORING_VENDOR = 'SUCCESS_GET_DETAIL_EVALUASI_MONITORING_VENDOR';
export const FAIL_GET_DETAIL_EVALUASI_MONITORING_VENDOR = 'FAIL_GET_DETAIL_EVALUASI_MONITORING_VENDOR';
export const SUCCESS_GET_OA = 'SUCCESS_GET_OA';
export const FAIL_GET_OA = 'FAIL_GET_OA';
export const SUCCESS_SUBMIT_OA = 'SUCCESS_SUBMIT_OA';
export const FAIL_SUBMIT_OA = 'FAIL_SUBMIT_OA';
export const SUCCESS_SUBMIT_PL = 'SUCCESS_SUBMIT_PL';
export const FAIL_SUBMIT_PL = 'FAIL_SUBMIT_PL';
export const SUCCESS_GET_PPHK = 'SUCCESS_GET_PPHK';
export const FAIL_GET_PPHK = 'FAIL_GET_PPHK';
export const SUCCESS_GET_RO = 'SUCCESS_GET_RO';
export const FAIL_GET_RO = 'FAIL_GET_RO';
export const SUCCESS_GET_STATUS_TENDER = 'SUCCESS_GET_STATUS_TENDER';
export const FAIL_GET_STATUS_TENDER = 'FAIL_GET_STATUS_TENDER';
export const RESET_STATUS_TENDER = 'RESET_STATUS_TENDER';
